import { TApplicationState } from 'shared/types/redux';

export function priceForObjectSelector(state: TApplicationState) {
  return state.newbuilding.priceForObjectFromDeveloperDisplay;
}
